var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrackYellowArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70897 14.4995C4.96625 14.7568 5.38336 14.7568 5.64064 14.4995L9.83311 10.307C10.0904 10.0498 10.0904 9.63266 9.83311 9.37539C9.57584 9.11812 9.15872 9.11812 8.90145 9.37539L5.1748 13.102L1.44816 9.37539C1.19089 9.11812 0.773771 9.11812 0.5165 9.37539C0.259229 9.63266 0.259229 10.0498 0.5165 10.307L4.70897 14.4995ZM5.1748 14.0337H5.83359L5.83359 0.858015H5.1748H4.51602L4.51602 14.0337H5.1748Z",
    fill: "url(#paint0_linear_109_502)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_502",
    x1: 5.82719,
    y1: 6.20448,
    x2: 5.9497,
    y2: 2.88783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D633"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrackYellowArrow);
export default __webpack_public_path__ + "static/media/crack-yellow-arrow.62ada815c398cb398dfe26b49ec21673.svg";
export { ForwardRef as ReactComponent };